<template>
  <div class="class-index">
    <div class="container-fluid mt-1">
      <div class="row">
        <div class="col-xl-8 mb-5 mb-xl-0">
          <div class="card">
            <div class="card-header">
              <div class="col">
                <h6 class="text-uppercase ls-1 mb-1">Daftar Mata Pelajaran</h6>
              </div>
            </div>
            <div class="card-body">
              <div class="table-class-list px-2">
                <div v-for="(item, index) in subjectList" :key="index">
                  <div class="col-lg-9 materi-name line-with-icon my-2" style="cursor: pointer" v-b-toggle="'collapse-modul-' + item.id">
                    <i class="clr-red fa fa-bookmark" aria-hidden="true"></i>
                    <div class="ml-1">
                      <b>
                        {{ item.name }}
                      </b>
                    </div>
                  </div>
                  <b-collapse visible :id="'collapse-modul-' + item.id">
                    <b-card>
                      <table class="table table-striped">
                        <tr v-for="(item1, index1) in item.subjectList" :key="index1">
                          <td style="width: 5%" class="class-list">
                            <h6 class="text-uppercase ls-1 mb-1 line-with-icon">
                              <p>{{ item1.no_urut }}</p>
                            </h6>
                          </td>
                          <td style="width: 100%" class="class-list">
                            <h6 class="text-uppercase ls-1 mb-1 line-with-icon">
                              <router-link :to="{ name: 'subject-detail', params: { classId: item1.id } }">{{ item1.name }}</router-link>
                            </h6>
                          </td>
                          <td>
                            <b-dropdown id="class-list-action" right text="AKSI" size="sm" class="m-md-2">
                              <b-dropdown-item @click="showMapelSettingFormModal(item1)"><i class="fa fa-edit" aria-hidden="true"></i>Edit</b-dropdown-item>
                              <b-dropdown-item @click="confirmDeleteSubject(item1.id)"><i class="fa fa-trash" aria-hidden="true"></i>Hapus Mata Pelajaran</b-dropdown-item>
                            </b-dropdown>
                          </td>
                        </tr>
                      </table>
                    </b-card>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-header">
              <div class="col">
                <h6 class="text-uppercase ls-1 mb-1">Info</h6>
              </div>
            </div>
            <div class="card-body">
              <div class="identity px-2">
                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{ user.full_name }}</p>
                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{ user.type }}</p>
                <p class="line-with-icon"><i class="clr-red fa fa-envelope" aria-hidden="true"></i>{{ user.email }}</p>
              </div>
            </div>
          </div>
          <card header-classes="bg-transparent" class="mt-4">
            <div slot="header" class="row align-items-center">
              <div class="d-flex justify-content-between" style="align-items: center">
                <div>
                  <h6 class="text-uppercase ls-1 mb-1">DAFTAR MAPEL</h6>
                </div>
                <div>
                  <b-dropdown id="dropdown-1" right text="AKSI" size="sm" class="m-md-2">
                    <template>
                      <b-dropdown-item v-if="user.type == 'tutor' || user.type == 'admin'">
                        <i class="fa fa-cogs" aria-hidden="true"></i>
                        <router-link :to="{ name: 'subject-list' }" class="text-black">Kelola Mata Pelajaran</router-link>
                      </b-dropdown-item>
                      <a href="javascript:void(0)" to="#" class="dropdown-item" @click="showAddSubjectModal"><i class="fa fa-plus-circle"></i><span>Tambah Mata Pelajaran</span></a>
                    </template>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div class="class-list px-2">
              <div v-for="(item, index) in subjectList" :key="index">
                <div class="col-lg-9 materi-name line-with-icon my-2" style="cursor: pointer" v-b-toggle="'collapse-modul-' + item.id">
                  <i class="clr-red fa fa-bookmark" aria-hidden="true"></i>
                  <div class="ml-1">
                    <b>
                      {{ item.name }}
                    </b>
                  </div>
                </div>
                <b-collapse visible :id="'collapse-modul-' + item.id">
                  <b-card>
                    <div>
                      <p v-for="(item1, index1) in item.subjectList" :key="index1" class="line-with-icon">
                        <i class="clr-red fa fa-book" aria-hidden="true"></i>
                        <router-link :to="{ name: 'subject-detail', params: { subjectId: item1.id } }">{{ item1.name }}</router-link>
                      </p>
                    </div>
                  </b-card>
                </b-collapse>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
    <b-modal ref="new-subject-modal" class="new-subject-modal" size="md" title="Tambah Mata Pelajaran Baru" @show="resetAddSubjectForm" @hidden="resetAddSubjectForm" hide-footer no-close-on-backdrop>
      <add-subject-form :classId="classId"></add-subject-form>
    </b-modal>
    <b-modal ref="mapel-setting-form-modal" class="mapel-setting-form-modal" size="md" title="Edit Pelajaran" @show="resetMapelSettingForm" @hidden="resetMapelSettingForm" hide-footer no-close-on-backdrop>
      <div class="mapel-setting-form">
        <div>
          <b-form data-vv-scope="mapel-setting-form">
            <b-form-group label="Semester" label-for="semester" label-cols-sm="3" label-align-sm="left">
              <b-form-select v-model="edit_mapel_setting_form.semester" name="semester" data-vv-as="Semester" :options="semesterList"></b-form-select>
              <span :class="{ 'error-validation': errors.first('mapel-setting-form.semester') }">{{ errors.first("mapel-setting-form.semester") }}</span>
            </b-form-group>
            <b-form-group label="Nama Mata Pelajaran" label-for="name" label-cols-sm="3" label-align-sm="left">
              <b-form-input
                id="input-nama-pelajaran"
                name="subject_name"
                data-vv-as="Nama mata pelajaran"
                v-model="edit_mapel_setting_form.name"
                type="text"
                placeholder="Nama Mata Pelajaran"
                v-validate="'required'"
                autocomplete="off"
              ></b-form-input>
              <span :class="{ 'error-validation': errors.first('mapel-setting-form.subject_name') }">{{ errors.first("mapel-setting-form.subject_name") }}</span>
            </b-form-group>
            <b-form-group label="Nomor Urut" label-for="no_urut" label-cols-sm="3" label-align-sm="left">
              <b-form-input id="input-nama-pelajaran" name="no_urut" data-vv-as="Nomor Urut" v-model="edit_mapel_setting_form.no_urut" type="text" placeholder="Nomor Urut" v-validate="'required'" autocomplete="off"></b-form-input>
              <span :class="{ 'error-validation': errors.first('mapel-setting-form.no_urut') }">{{ errors.first("mapel-setting-form.no_urut") }}</span>
            </b-form-group>
          </b-form>
        </div>
        <hr />
        <div class="new-class-footer d-flex justify-content-end">
          <square-loader :loading="showLoaderMapelSetting" :color="'#ca062a'" :size="'30px'"></square-loader>
          <b-button v-if="!showLoaderMapelSetting" variant="outline-danger" size="md" style="width: 25%" @click="hideMapelSettingFormModal">BATAL</b-button>
          <b-button v-if="!showLoaderMapelSetting" variant="primary" size="md" style="width: 25%" @click.prevent="saveMapelSetting">SIMPAN</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/eventBus.js";
import SquareLoader from "vue-spinner/src/SquareLoader.vue";
import AddSubjectForm from "../../../components/Main/AddSubjectForm";
export default {
  props: {
    semesterList: {
      type: Array,
      default() {
        return [
          {
            value: "1",
            text: "Ganjil",
          },
          {
            value: "2",
            text: "Genap",
          },
        ];
      },
    },
  },
  components: {
    AddSubjectForm,
    SquareLoader,
  },
  data() {
    return {
      classId: this.$route.params.classId,
      showLoaderMapelSetting: false,
      edit_mapel_setting_form: {
        id: null,
        semester: null,
        name: null,
        no_urut: null,
        class_id: null,
        user_id: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      isAdmin: "isAdmin",
      isTutor: "isTutor",
      subjectList: "getSubjectList",
    }),
  },
  methods: {
    showAddSubjectModal() {
      this.$refs["new-subject-modal"].show();
    },
    hideAddSubjectModal() {
      this.$refs["new-subject-modal"].hide();
      this.resetAddSubjectForm();
    },
    resetAddSubjectForm() {
      EventBus.$emit("resetAddSubjectForm", true);
    },
    showMapelSettingFormModal(param) {
      this.edit_mapel_setting_form = param;
      this.$refs["mapel-setting-form-modal"].show();
    },
    hideMapelSettingFormModal() {
      this.$refs["mapel-setting-form-modal"].hide();
      this.resetMapelSettingForm();
    },
    resetMapelSettingForm() {
      //   this.edit_mapel_setting_form.id = this.subjectDetail.id;
      //   this.edit_mapel_setting_form.name = this.subjectDetail.name_edit;
      //   this.edit_mapel_setting_form.no_urut = this.subjectDetail.no_urut;
      //   this.edit_mapel_setting_form.semester = this.subjectDetail.semester;
      //   this.edit_mapel_setting_form.class_id = this.subjectDetail.class_id;
      //   this.edit_mapel_setting_form.user_id = this.user.id;
    },
    async confirmDeleteSubject(id) {
      this.$swal
        .fire({
          title: "Apakah anda yakin?",
          text: "Data akan terhapus dan tidak dapat dikembalikan lagi!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            let form = {
              subject_id: id,
            };
            this.deleteSubject(form);
          }
        });
    },
    async deleteSubject(form) {
      await this.$store
        .dispatch("deleteSubject", form)
        .then((res) => {
          this.$swal.fire("Success", res.message, "success");
          this.getSubjectList();
        })
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async saveMapelSetting() {
      let scope = "mapel-setting-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoaderMapelSetting = true;
          let form = this.edit_mapel_setting_form;
          this.$store
            .dispatch("editSubject", form)
            .then((res) => {
              this.showLoaderMapelSetting = false;
              this.getSubjectList();
              this.hideMapelSettingFormModal();
              this.$swal.fire("Success", res.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoaderMapelSetting = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Failed", error.data.message, "error");
              }
            });
        }
      });
    },
    async getSubjectList() {
      this.showLoader = true;
      let classId = this.classId;
      await this.$store
        .dispatch("getSubjectList", { classId })
        .then(() => {
          this.showLoader = false;
        })
        .catch((err) => {
          this.showLoader = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
  },
  async created() {
    this.getSubjectList();
    EventBus.$on("hideAddSubjectModal", (val) => {
      if (val) {
        this.hideAddSubjectModal();
      }
    });
  },
};
</script>
<style lang="css" scoped>
.table td {
  padding-top: unset;
  padding-bottom: unset;
  vertical-align: unset;
}
</style>
